import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthDebug: React.FC = () => {
  const { user, profile, loading } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Only open automatically for super_admin in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && profile?.role === 'super_admin') {
      setIsOpen(true);
    }
  }, [profile?.role]);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // Only render for super_admin
  if (profile?.role !== 'super_admin') {
    return null;
  }

  return (
    <div className={`fixed bottom-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg text-xs max-w-md z-50 ${isOpen ? '' : 'hidden'}`}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-bold">Auth Debug</h3>
        <button
          onClick={() => setIsOpen(false)}
          className="ml-2 text-gray-300 hover:text-white"
          aria-label="Close"
          title="Close"
        >
          ✕
        </button>
      </div>
      <div className="space-y-1">
        <div>Loading: {loading ? 'Yes' : 'No'}</div>
        <div>User ID: {user?.id || 'null'}</div>
        <div>Email: {user?.email || 'null'}</div>
        <div>Profile ID: {profile?.id || 'null'}</div>
        <div className="font-bold text-yellow-300">Role: {profile?.role || 'null/undefined'}</div>
        <div>Account Type (internal): {profile?.account_type || 'null'}</div>
        <div className="mt-3 space-x-2">
          <button 
            onClick={() => (window as any).forceRefreshProfile?.()}
            className="bg-blue-500 text-white px-2 py-1 rounded text-xs hover:bg-blue-600"
          >
            Refresh Profile
          </button>
          <button 
            onClick={() => window.location.href = '/admin'}
            className="bg-green-500 text-white px-2 py-1 rounded text-xs hover:bg-green-600"
          >
            Go to Admin
          </button>
          <button 
            onClick={() => window.location.href = '/test-admin'}
            className="bg-purple-500 text-white px-2 py-1 rounded text-xs hover:bg-purple-600"
          >
            Test Route
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthDebug;
